var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.23 14.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:1.5px;}.cls-1,.cls-2,.cls-3{fill:none;stroke:#c9c9c9;stroke-miterlimit:10;}.cls-2{stroke-width:1.3px;}.cls-3{stroke-width:1.7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m23.92,2.97V.85L.85.93c0,1.05,0,2.1,0,3.16,1.53-.04,2.74,1.24,2.66,2.65-.07,1.31-1.24,2.41-2.66,2.37v3.4c5.54,0,11.09,0,16.63-.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.64,
    y1: 3.06,
    x2: 6.64,
    y2: 10.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.88,
    cy: 9.48,
    r: 4.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.9,
    y1: 6.94,
    x2: 23.9,
    y2: 12.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.32,
    y1: 9.62,
    x2: 26.38,
    y2: 9.62
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.27c4a8a6dd0205568519b1c6b98d33e8.svg";
export { ForwardRef as ReactComponent };